import React, { useState, useMemo, useEffect } from "react";
import {
  Box,
  CssBaseline,
  ThemeProvider,
  Toolbar,
  createTheme,
  useMediaQuery,
} from "@mui/material";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "./components/Header";
import "./i18n/i18n";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MainLayout from "./components/MainLayout";
import Home from "./pages/Home/Home";
import NotFoundPage from "./components/NotFoundPage";
import Maintenance from "./components/Maintenance";
import LoginPage from "./pages/LoginPage/LoginPage";

import { getUserCookie } from "./hooks/authCookies";


import { useDispatch } from "react-redux";
import ProtectedRoute from "./Auth/ProtectedRoute";
import SecondHeader from "./components/SecondHeader/SecondHeader";
import Footer from "./components/Footer";
import Admissions from "./pages/Admissions/Admissions";
import StudentDashboard from "./pages/StudentDashboard/StudentDashboard";
import ProfilePage from "./pages/ProfilePage/ProfilePage";
import FeePaymentPage from "./pages/FeePaymentPage/FeePaymentPage";
import UsersPage from "./pages/Users/Users";
import UserDetails from "./pages/Users/UserDetails";
import LeadersArticlesPage from "./pages/Home/LeadersArticlesPage";
import LeaderBiographyPage from "./pages/Home/LeaderBiographyPage";
import StudentVoicesPage from "./pages/Home/StudentVoicesPage";
import NewsPage from "./pages/Home/NewsPage";
import ArticalDetails from "./pages/Home/ArticalDetails";
import AllNationalitiesPage from "./pages/nationality/AllNationalitiesPage";

import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import AddNationalityPage from "./pages/nationality/AddNationalityPage";
import NationalityDetailsPage from "./pages/nationality/NationalityDetailsPage";
import AllCountriesPage from "./pages/Countries/AllCountriesPage";
import AddCountryPage from "./pages/Countries/AddCountryPage";
import CountryDetailsPage from "./pages/Countries/CountryDetailsPage";
import AllCitiesInOneCountryPage from "./pages/Countries/AllCitiesInOneCountryPage";
import AddCityPage from "./pages/Countries/AddCityPage";
import CityDetailsPage from "./pages/Countries/CityDetailsPage";
import AllfaculitiesPage from "./pages/Faculities/AllfaculitiesPage";
import AddFaculityPage from "./pages/Faculities/AddFaculityPage";
import FaculityDetailsPage from "./pages/Faculities/FaculityDetailsPage";

import AllDepartmnentsPage from "./pages/Departments/AllDepartmnentsPage";
import AddDepartmentPage from "./pages/Departments/AddDepartmentPage";
import DepartmentDetailsPage from "./pages/Departments/DepartmentDetailsPage";
import AllAcademyTermsPage from "./pages/AcademyTerms/AllAcademyTermsPage";
import AddAcademyTermPage from "./pages/AcademyTerms/AddAcademyTermPage";
import AllMaterialsPage from "./pages/Materials/AllMaterialsPage";
import AddMaterialPage from "./pages/Materials/AddMaterialPage";
import MaterialDetailsPage from "./pages/Materials/MaterialDetailsPage";
import AllFeesTypesPage from "./pages/FeesTypes/AllFeesTypesPage";
import AddFeesTypesPage from "./pages/FeesTypes/AddFeesTypesPage";
import FeeDetailsPage from "./pages/FeesTypes/FeeDetailsPage";
import AllTransactionsPage from "./pages/Transactions/AllTransactionsPage";
import AddTransactionPage from "./pages/Transactions/AddTransactionPage";
import TransactionDetailsPage from "./pages/Transactions/TransactionDetailsPage";
import TransactionLogsPage from "./pages/Transactions/TransactionLogsPage";
import AcademyTermDetailsPage from "./pages/AcademyTerms/AcademyTermDetailsPage";
import AllTransactionTypesPage from "./pages/TransactionTypes/AllTransactionTypesPage";
import AddTransactionTypePage from "./pages/TransactionTypes/AddTransactionTypePage";
import TransactionTypeDetailsPage from "./pages/TransactionTypes/TransactionTypeDetailsPage";
import AllFaculitiesPricesPage from "./pages/FaculitiesPrices/AllFaculitiesPricesPage";
import AddFaculityPricePage from "./pages/FaculitiesPrices/AddFaculityPricePage";
import FaculityPriceDetailsPage from "./pages/FaculitiesPrices/FaculityPriceDetailsPage";
import AllDepartmentsPage from "./pages/websiteDepartments/AllDepartmentsPage";
import AddWebsiteDepartmentPage from "./pages/websiteDepartments/AddWebsiteDepartmentPage";
import AllArticlesPage from "./pages/WebsiteArticles/AllArticlesPage";
import AddArticlePage from "./pages/WebsiteArticles/AddArticlePage";
import ArticleDetailsPage from "./pages/WebsiteArticles/ArticleDetailsPage";
import WebSiteDepartmentDetailsPage from "./pages/websiteDepartments/WebSiteDepartmentDetailsPage";
import AllUsersPage from "./pages/UsersPage/AllUsersPage";
import AddUserPage from "./pages/UsersPage/AddUserPage";
import UserDetailsPage from "./pages/UsersPage/UserDetailsPage";
import AllRequiredFeesPage from "./pages/StudentRequiredFees/AllRequiredFeesPage";
import AddRequiredFeesPage from "./pages/StudentRequiredFees/AddRequiredFeesPage";
import RequiredFeeDetailsPage from "./pages/StudentRequiredFees/RequiredFeeDetailsPage";
import AllRegisterFormsPage from "./pages/RegisterForms/AllRegisterFormsPage";
import RegisterFormDetailsPage from "./pages/RegisterForms/RegisterFormDetailsPage";
import SubTitleDetailsPage from "./pages/websiteDepartments/SubTitleDetailsPage";
import AllLecturesPage from "./pages/LecturesSchedule/AllLecturesPage";
import AddLecturePage from "./pages/LecturesSchedule/AddLecturePage";
import LectureDetailsPage from "./pages/LecturesSchedule/LectureDetailsPage";
import EditLecturePage from "./pages/LecturesSchedule/EditLecturePage";
import DoctorLecturesPage from "./pages/DoctorDashboard/DoctorLectures/DoctorLecturesPage";
import StudentLecturesPage from "./pages/StudentDashboard/StudentlecturesSchedule/StudentLecturesPage";
import LectureSessionDetails from "./pages/LectureSessionDetails/LectureSessionDetails";
import AllLectureSessionsPage from "./pages/LectureSessionDetails/AllLectureSessionsPage";
import AllExamsPage from "./pages/Exams/AllExamsPage";
import AddExamPage from "./pages/Exams/AddExamPage";
import ExamDetailsPage from "./pages/Exams/ExamDetailsPage";
import ExamStudentDegreesPage from "./pages/Exams/ExamStudentDegreesPage";
import AddExamStudentDegreePage from "./pages/Exams/AddExamStudentDegreePage";
import StudentDegreesDetailsPage from "./pages/Exams/StudentDegreesDetailsPage";
import AllDegreesForStudentPage from "./pages/Exams/AllDegreesForStudentPage";
import AllStudentDegreesPage from "./pages/StudentDegrees/AllStudentDegreesPage";
import GetAllSupportTicketsPage from "./pages/SupportTickets/GetAllSupportTicketsPage";
import AddSupportTicketPage from "./pages/SupportTickets/AddSupportTicketPage";
import EditSupportTicketPage from "./pages/SupportTickets/EditSupportTicketPage";
import AllSupportTicketTypesPage from "./pages/SupportTicketTypes/AllSupportTicketTypesPage";
import AddSupportTicketTypePage from "./pages/SupportTicketTypes/AddSupportTicketTypePage";
import EditSupportTicketTypePage from "./pages/SupportTicketTypes/EditSupportTicketTypePage";
import PermissionsGroupsPage from "./pages/PermissionsGroupsPage/PermissionsGroupsPage";
import GroupFormPage from "./pages/PermissionsGroupsPage/GroupFormPage";
import ELibraryPage from "./pages/E-Library/ELibraryPage";
import AddBookPage from "./pages/E-Library/AddBookPage";
import BookDetailsPage from "./pages/E-Library/BookDetailsPage";
import AllContactMessagesPage from "./pages/ContactUs/AllContactMessagesPage";
import SiteSettings from "./pages/SiteSettings/SiteSettings";
import AllSignaturesPage from "./pages/admin/signatures/AllSignaturesPage";
import AddSignaturePage from "./pages/admin/signatures/AddSignaturePage";
import SignatureDetailsPage from "./pages/admin/signatures/SignatureDetailsPage";
import AllJobTitlesPage from "./pages/JobTitles/AllJobTitlesPage";
import BackupsPage from "./pages/Backups/BackupsPage";
import TestCertificatePage from "./pages/TestCertificatePage";
import PromotionPage from "./pages/Promotion/PromotionPage";
import SummerCourseAdminPage from "./pages/SummerCourseAdmin/SummerCourseAdminPage";
import Installments from "./pages/Installments/Installments";
import InstallmentDetails from "./pages/Installments/InstallmentDetails";
import StudentInstallmentsPage from "./pages/StudentDashboard/StudentInstallments/StudentInstallmentsPage";
import AllTypeSequencesPage from "./pages/TypeSequences/AllTypeSequencesPage";
import AddTypeSequencePage from "./pages/TypeSequences/AddTypeSequencePage";
import EditTypeSequencePage from "./pages/TypeSequences/EditTypeSequencePage";
import AllSequenceTransPage from "./pages/SequenceTrans/AllSequenceTransPage";
import AddSequenceTransPage from "./pages/SequenceTrans/AddSequenceTransPage";
import EditSequenceTransPage from "./pages/SequenceTrans/EditSequenceTransPage";

// Public Site Config Pages
import PrivacyPolicy from "./pages/Home/PrivacyPolicy";
import TermsOfService from "./pages/Home/TermsOfService";
import Accessibility from "./pages/Home/Accessibility";
import ContactUs from "./pages/Home/ContactUs";
import SuccessPaymentPage from "./pages/PaymentResult/SuccessPaymentPage";
import FailedPaymentPage from "./pages/PaymentResult/FailedPaymentPage";
import AddPromotionPage from "./pages/Promotion/AddPromotionPage";
import MaterialEquivalence from "./pages/SupportTickets/MaterialEquivalence";
import AcademicsPage from "./pages/Home/AcademicsPage";

export const ColorModeContext = React.createContext({
  toggleColorMode: () => { },
});

function App() {
  const [mode, setMode] = useState("light");
  const { i18n } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const isArabic = i18n.language === "ar";

  // إنشاء cache يدعم RTL
  const cacheRtl = createCache({
    key: "mui-rtl",
    stylisPlugins: [prefixer, rtlPlugin],
  });

  // Update direction and language in localStorage
  useEffect(() => {
    const storedMode = localStorage.getItem("theme-mode");
    if (storedMode) {
      setMode(storedMode);
    }

    const storedLanguage = localStorage.getItem("language");
    if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
      document.documentElement.dir = storedLanguage === "ar" ? "rtl" : "ltr";
    } else {
      document.documentElement.dir = i18n.language === "ar" ? "rtl" : "ltr";
    }
  }, [i18n]);

  // Listen for language changes to update RTL/LTR
  useEffect(() => {
    document.documentElement.dir = i18n.language === "ar" ? "rtl" : "ltr";
    localStorage.setItem("language", i18n.language);
  }, [i18n.language]);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => {
          const newMode = prevMode === "light" ? "dark" : "light";
          localStorage.setItem("theme-mode", newMode);
          return newMode;
        });
      },
    }),
    []
  );

  const theme = useMemo(
    () =>
      createTheme({
        direction: i18n.language === "ar" ? "rtl" : "ltr",

        palette: {
          mode,
          primary: {
            main: mode === "light" ? "#095690" : "#22ABCE",
            textField: "#E8EDF2",
            textFieldText: "#4D7399",
            gray: "#F9FAFB",
            contrastText: "#ffffff",
            tabelHeader: "#D2D6DB",
            disabled: "#384250"
          },
          secondary: {
            main: mode === "light" ? "#F39A15" : "#F39A15",
            contrastText: "#ffffff",
          },
          info: {
            main: "#22ABCE",
            secondary: "#384250",
            // title:"#384250",
            subtitle: "#9DA4AE"
          },
          background: {
            default: mode === "light" ? "#ffffff" : "#0f172a",
            paper: mode === "light" ? "#ffffff" : "#1e293b",
            secDefault: mode === "light" ? "#CFDBE8" : "#1f2937",
            gray: mode === "light" ? "#E5E5E5" : "#334155",
            green: "",
            inputBackGround: "#E8EDF2"
          },
          text: {
            primary: mode === "light" ? "#0f172a" : "#f1f5f9",
            sec: mode === "light" ? "#f1f5f9" : "#0f172a",
            secondary: mode === "light" ? "#475569" : "#CBD5E1",
          },
          whiteText: {
            primary: mode === "light" ? "#ffffff" : "#191C32",
          },
        },
        typography: {
          fontFamily: ["Cairo", "Arial", "sans-serif"].join(","),
        },
        shape: {
          borderRadius: 8,
        },
        components: {
          MuiCssBaseline: {
            styleOverrides: {
              body: {
                backgroundColor:
                  mode === "light"
                    ? "#ffffff"
                    : "linear-gradient(220deg, #0f172a 0%, #1e293b 100%)",
                color: mode === "light" ? "#0f172a" : "#f1f5f9",
                backgroundAttachment: "fixed",
                backgroundSize: "cover",
                minHeight: "100vh",
                margin: 0,
                padding: 0,
                scrollbarColor:
                  mode === "dark" ? "#22ABCE #1e293b" : "#095690 #CFDBE8",
              },
              "body::-webkit-scrollbar, *::-webkit-scrollbar": {
                width: 8,
                height: 8,
              },
              "body::-webkit-scrollbar-thumb, *::-webkit-scrollbar-thumb": {
                borderRadius: 8,
                backgroundColor: mode === "dark" ? "#22ABCE" : "#095690",
              },
              "body::-webkit-scrollbar-thumb:hover": {
                backgroundColor: mode === "dark" ? "#F39A15" : "#22ABCE",
              },
              "body::-webkit-scrollbar-track, *::-webkit-scrollbar-track": {
                borderRadius: 8,
                backgroundColor: mode === "dark" ? "#1e293b" : "#E5E5E5",
              },
            },
          },
          MuiButton: {
            styleOverrides: {
              root: {
                borderRadius: "8px",
                fontWeight: 600,
                textTransform: "none",
                boxShadow: "none",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-2px)",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                },
              },
              containedPrimary: {
                backgroundColor: "#095690",
                color: "#ffffff",
                "&:hover": {
                  backgroundColor: mode === "light" ? "#07406d" : "#22ABCE",
                },
              },
              containedSecondary: {
                backgroundColor: "#F39A15",
                color: "#ffffff",
                "&:hover": {
                  backgroundColor: mode === "light" ? "#d6810d" : "#f59e0b",
                },
              },
            },
          },
          MuiCard: {
            styleOverrides: {
              root: {
                backgroundColor:
                  mode === "light" ? "#ffffff" : "rgba(30, 41, 59, 0.9)",
                backdropFilter: "blur(8px)",
                boxShadow:
                  mode === "light"
                    ? "0px 4px 15px rgba(0, 0, 0, 0.1)"
                    : "0px 4px 15px rgba(0, 0, 0, 0.3)",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow:
                    mode === "light"
                      ? "0px 8px 25px rgba(0, 0, 0, 0.15)"
                      : "0px 8px 25px rgba(0, 0, 0, 0.4)",
                },
              },
            },
          },
          MuiAppBar: {
            styleOverrides: {
              root: {
                backgroundColor:
                  mode === "light"
                    ? "rgba(255, 255, 255, 0.95)"
                    : "rgba(15, 23, 42, 0.95)",
                backdropFilter: "blur(8px)",
                boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
              },
            },
          },
          MuiTextField: {
            styleOverrides: {
              root: {
                backgroundColor:
                  mode === "light" ? "#ffffff" : "rgba(30, 41, 59, 0.8)",
                borderRadius: "8px",
              },
            },
          },
        },
      }),
    [mode, i18n.language]
  );

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const user = getUserCookie();

  // ======= Replace the old polling block with this =======

  const isLoggedIn = Boolean(user);

  // useEffect(() => {
  //   if (!isLoggedIn) return;

  //   dispatch(getAllNotifications());

  //   const interval = setInterval(() => {
  //     dispatch(getAllNotifications());
  //   }, 60000);

  //   return () => clearInterval(interval);
  // }, [dispatch, isLoggedIn]);

  const hideHeader = location.pathname != "/login";
  const hideSecandHeader =
    location.pathname == "/home" ||
    location.pathname == "/visionsArticals" ||
    location.pathname == "/leaders-articles" ||
    location.pathname == "/student-voices" ||
    location.pathname == "/student-voices" ||
    location.pathname == "/news";

  return (
    <ColorModeContext.Provider value={colorMode}>
      <CacheProvider value={cacheRtl}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <div
            className="App"
            style={{
              display: "flex",
              flexDirection: "column",
              minHeight: "100vh",
            }}
          >
            <Box
              sx={{
                position: 'fixed', // تغيير الـ sticky إلى fixed لضمان الثبات الكامل أثناء السكرول
                top: 0,
                left: 0,
                right: 0,
                zIndex: 1100, // الـ zIndex هنا ليكون فوق المحتوى فقط وليس فوق المودال والتوست
                width: '100%',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              {/* {hideHeader && */}
              <Header />
              {/* } */}
              <SecondHeader />

            </Box>


            <main
              style={{
                flex: 1,
                paddingTop: isLoggedIn 
                  ? (isMobile ? "60px" : "80px") 
                  : (isMobile ? "100px" : "133px")
              }}
            >              <Routes>
                {/* المسارات العامة */}
                <Route path="/" element={<Navigate to="/home" />} />
                {/* <Route path="/login" element={<LoginScreen />} /> */}

                {/* المسارات الخاصة التي تظهر فيها Sidebar */}
                <Route
                  path="/login"
                  element={
                    // <MainLayout>
                    <LoginPage />
                    // </MainLayout>
                  }
                />
                <Route element={<ProtectedRoute />}>
                  <Route
                    path="/academics"
                    element={
                      <MainLayout>
                        <AcademicsPage />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/leaders-articles"
                    element={
                      <MainLayout>
                        <LeadersArticlesPage />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/leader-biography/:id"
                    element={
                      <MainLayout>
                        <LeaderBiographyPage />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/student-voices"
                    element={
                      <MainLayout>
                        <StudentVoicesPage />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/student-voices/:id"
                    element={
                      <MainLayout>
                        <LeaderBiographyPage />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/news"
                    element={
                      <MainLayout>
                        <NewsPage />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/home"
                    element={
                      <MainLayout>
                        <Home />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/ArticalDetails/:id"
                    element={
                      <MainLayout>
                        <ArticalDetails />
                      </MainLayout>
                    }
                  />

                  <Route
                    path="/Admissions"
                    element={
                      <MainLayout>
                        <Admissions />
                      </MainLayout>
                    }
                  />

                  {/* Public Details Pages */}
                  <Route path="/privacy-policy" element={<MainLayout><PrivacyPolicy /></MainLayout>} />
                  <Route path="/terms-of-service" element={<MainLayout><TermsOfService /></MainLayout>} />
                  <Route path="/accessibility" element={<MainLayout><Accessibility /></MainLayout>} />
                  <Route path="/contact-us" element={<MainLayout><ContactUs /></MainLayout>} />
                  <Route path="/test-certificate" element={<TestCertificatePage />} />

                  {/* Payment Result Pages */}
                  <Route path="/payment-success" element={<MainLayout><SuccessPaymentPage /></MainLayout>} />
                  <Route path="/payment-failed" element={<MainLayout><FailedPaymentPage /></MainLayout>} />

                  {/* student dashboard */}
                  <Route
                    path="/StudentDashboard"
                    element={
                      <MainLayout isLoggedIn={true}>
                        <StudentDashboard />
                      </MainLayout>
                    }
                  />

                  <Route
                    path="/StudentlecturesSchedule"
                    element={
                      <MainLayout isLoggedIn={true}>
                        <StudentLecturesPage />
                      </MainLayout>
                    }
                  />

                  <Route
                    path="/profile"
                    element={
                      <MainLayout isLoggedIn={true}>
                        <ProfilePage />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/FeePayment"
                    element={
                      <MainLayout isLoggedIn={true}>
                        <FeePaymentPage />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/student/installments"
                    element={
                      <MainLayout isLoggedIn={true}>
                        <StudentInstallmentsPage />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/StudentInstallments"
                    element={
                      <MainLayout isLoggedIn={true}>
                        <StudentInstallmentsPage />
                      </MainLayout>
                    }
                  />

                  {/* <Route
                    path="/Users"
                    element={
                      <MainLayout>
                        <UsersPage />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/UserDetails/:id"
                    element={
                      <MainLayout>
                        <UserDetails />
                      </MainLayout>
                    }
                  /> */}

                  {/* Installments الاقساط */}
                  <Route path="/installments">
                    <Route
                      index
                      element={
                        <MainLayout isLoggedIn={true}>
                          <Installments />
                        </MainLayout>
                      }
                    />
                    <Route
                      path="details/:id"
                      element={
                        <MainLayout isLoggedIn={true}>
                          <InstallmentDetails />
                        </MainLayout>
                      }
                    />
                  </Route>

                  {/* website Departments  الاقسام */}

                  <Route path="/website-departments">
                    <Route
                      index
                      element={
                        <MainLayout isLoggedIn={true}>
                          <AllDepartmentsPage />
                        </MainLayout>
                      }
                    />
                    <Route
                      path="details/:id/add"
                      element={
                        <MainLayout isLoggedIn={true}>
                          <AddWebsiteDepartmentPage />
                        </MainLayout>
                      }
                    />

                    <Route
                      path="details/:id/edit/:DepID"
                      element={
                        <MainLayout isLoggedIn={true}>
                          <SubTitleDetailsPage />
                        </MainLayout>
                      }
                    />

                    <Route
                      path="details/:id"
                      element={
                        <MainLayout isLoggedIn={true}>
                          <WebSiteDepartmentDetailsPage />
                        </MainLayout>
                      }
                    />
                  </Route>

                  {/* المقالات */}
                  <Route path="/website-articles">
                    <Route
                      index
                      element={
                        <MainLayout isLoggedIn={true}>
                          <AllArticlesPage />
                        </MainLayout>
                      }
                    />
                    <Route
                      path="add"
                      element={
                        <MainLayout isLoggedIn={true}>
                          <AddArticlePage />
                        </MainLayout>
                      }
                    />

                    <Route
                      path="details/:id"
                      element={
                        <MainLayout isLoggedIn={true}>
                          <ArticleDetailsPage />
                        </MainLayout>
                      }
                    />
                  </Route>

                  {/* المستخدمين */}
                  <Route path="/PermissionsGroups">
                    <Route
                      index
                      element={
                        <MainLayout isLoggedIn={true}>
                          <PermissionsGroupsPage />
                        </MainLayout>
                      }
                    />
                    <Route
                      path="add"
                      element={
                        <MainLayout isLoggedIn={true}>
                          <GroupFormPage />
                        </MainLayout>
                      }
                    />

                    <Route
                      path="details/:id"
                      element={
                        <MainLayout isLoggedIn={true}>
                          <GroupFormPage />
                        </MainLayout>
                      }
                    />
                  </Route>

                  {/* Site Settings */}
                  <Route path="/site-settings" element={
                    <MainLayout isLoggedIn={true}>
                      <SiteSettings />
                    </MainLayout>
                  } />

                  {/* Signatures */}
                  <Route path="/signatures" element={
                    <MainLayout isLoggedIn={true}>
                      <AllSignaturesPage />
                    </MainLayout>
                  } />
                  <Route path="/signatures/add" element={
                    <MainLayout isLoggedIn={true}>
                      <AddSignaturePage />
                    </MainLayout>
                  } />
                  <Route path="/signatures/details/:id" element={
                    <MainLayout isLoggedIn={true}>
                      <SignatureDetailsPage />
                    </MainLayout>
                  } />

                  {/* Job Titles مسميات الموظفين */}
                  <Route path="/job-titles" element={
                    <MainLayout isLoggedIn={true}>
                      <AllJobTitlesPage />
                    </MainLayout>
                  } />

                  {/* Backups */}
                  <Route path="/backups" element={
                    <MainLayout isLoggedIn={true}>
                      <BackupsPage />
                    </MainLayout>
                  } />

                  {/* المستخدمين */}
                  <Route path="/users">
                    <Route
                      index
                      element={
                        <MainLayout isLoggedIn={true}>
                          <AllUsersPage />
                        </MainLayout>
                      }
                    />

                    <Route
                      path="add"
                      element={
                        <MainLayout isLoggedIn={true}>
                          <AddUserPage />
                        </MainLayout>
                      }
                    />

                    <Route
                      path="details/:id"
                      element={
                        <MainLayout isLoggedIn={true}>
                          <UserDetailsPage />
                        </MainLayout>
                      }
                    />

                  </Route>

                  {/* الجنسيات */}
                  <Route path="/nationality">
                    <Route
                      index
                      element={
                        <MainLayout isLoggedIn={true}>
                          <AllNationalitiesPage />
                        </MainLayout>
                      }
                    />

                    <Route
                      path="add"
                      element={
                        <MainLayout isLoggedIn={true}>
                          <AddNationalityPage />
                        </MainLayout>
                      }
                    />

                    <Route
                      path="details/:id"
                      element={
                        <MainLayout isLoggedIn={true}>
                          <NationalityDetailsPage />
                        </MainLayout>
                      }
                    />

                  </Route>

                  {/* البلاد و الدول */}
                  <Route path="/countries">

                    <Route
                      index
                      element={
                        <MainLayout isLoggedIn={true}>
                          <AllCountriesPage />
                        </MainLayout>
                      }
                    />

                    <Route
                      path="add"
                      element={
                        <MainLayout isLoggedIn={true}>
                          <AddCountryPage />
                        </MainLayout>
                      }
                    />

                    <Route
                      path="details/:id"
                      element={
                        <MainLayout isLoggedIn={true}>
                          <CountryDetailsPage />
                        </MainLayout>
                      }
                    />

                    <Route
                      path="cities/:id"
                      element={
                        <MainLayout isLoggedIn={true}>
                          <AllCitiesInOneCountryPage />
                        </MainLayout>
                      }
                    />

                    <Route
                      path="cities/:id/add"
                      element={
                        <MainLayout isLoggedIn={true}>
                          <AddCityPage />
                        </MainLayout>
                      }
                    />

                    <Route
                      path="cities/:id/details/:cityId"
                      element={
                        <MainLayout isLoggedIn={true}>
                          <CityDetailsPage />
                        </MainLayout>
                      }
                    />




                  </Route>

                  {/* الكليات */}
                  <Route path="/faculities">
                    <Route index element={
                      <MainLayout isLoggedIn={true}>
                        <AllfaculitiesPage />
                      </MainLayout>
                    } />

                    <Route path="add" element={
                      <MainLayout isLoggedIn={true}>
                        <AddFaculityPage />
                      </MainLayout>
                    } />

                    <Route path="details/:id" element={
                      <MainLayout isLoggedIn={true}>
                        <FaculityDetailsPage />
                      </MainLayout>
                    } />



                  </Route>

                  {/* الاقسام للكليات */}
                  <Route path="/departments">

                    <Route index element={
                      <MainLayout isLoggedIn={true}>
                        <AllDepartmnentsPage />
                      </MainLayout>
                    } />

                    <Route path="add" element={
                      <MainLayout isLoggedIn={true}>
                        <AddDepartmentPage />
                      </MainLayout>
                    } />

                    <Route path="details/:id" element={
                      <MainLayout isLoggedIn={true}>
                        <DepartmentDetailsPage />
                      </MainLayout>
                    } />


                  </Route>

                  {/* اسعار الكليات */}
                  <Route path="/prices">
                    <Route index element={
                      <MainLayout isLoggedIn={true}>
                        <AllFaculitiesPricesPage />
                      </MainLayout>
                    } />
                    <Route path="add" element={
                      <MainLayout isLoggedIn={true}>
                        <AddFaculityPricePage />
                      </MainLayout>
                    } />

                    <Route path="details/:id" element={
                      <MainLayout isLoggedIn={true}>
                        <FaculityPriceDetailsPage />
                      </MainLayout>
                    } />
                  </Route>
                  {/* المواد  (materials)*/}
                  <Route path="/materials">
                    <Route index element={
                      <MainLayout isLoggedIn={true}>
                        <AllMaterialsPage />
                      </MainLayout>
                    } />

                    <Route path="add" element={
                      <MainLayout isLoggedIn={true}>
                        <AddMaterialPage />
                      </MainLayout>
                    } />

                    <Route path="details/:id" element={
                      <MainLayout isLoggedIn={true}>
                        <MaterialDetailsPage />
                      </MainLayout>
                    } />

                  </Route>
                  {/* المواد  (ELibraryPage)*/}
                  <Route path="/ELibrary">
                    <Route index element={
                      <MainLayout isLoggedIn={true}>
                        <ELibraryPage />
                      </MainLayout>
                    } />

                    <Route path="add" element={
                      <MainLayout isLoggedIn={true}>
                        <AddBookPage />
                      </MainLayout>
                    } />

                    <Route path="details/:id" element={
                      <MainLayout isLoggedIn={true}>
                        <BookDetailsPage />
                      </MainLayout>
                    } />

                  </Route>


                  {/* الفصول الدراسية */}
                  <Route path="/academyTerms">
                    <Route index element={
                      <MainLayout isLoggedIn={true}>
                        <AllAcademyTermsPage />
                      </MainLayout>
                    } />

                    <Route path="add" element={
                      <MainLayout isLoggedIn={true}>
                        <AddAcademyTermPage />
                      </MainLayout>
                    } />
                    <Route path="details/:id" element={
                      <MainLayout isLoggedIn={true}>
                        <AcademyTermDetailsPage />
                      </MainLayout>
                    } />

                  </Route>

                  {/* المحاضرات */}
                  <Route path="/lecturesSchedule">
                    <Route index element={
                      <MainLayout isLoggedIn={true}>
                        <AllLecturesPage />
                      </MainLayout>
                    } />

                    <Route path="add" element={
                      <MainLayout isLoggedIn={true}>
                        <AddLecturePage />
                      </MainLayout>
                    } />
                    <Route path="details/:id" element={
                      <MainLayout isLoggedIn={true}>
                        <LectureDetailsPage />
                      </MainLayout>
                    } />
                    <Route path="edit/:id" element={
                      <MainLayout isLoggedIn={true}>
                        <EditLecturePage />
                      </MainLayout>
                    } />

                  </Route>

                  {/* انواع الرسوم */}
                  <Route path="/feesTypes">
                    <Route index element={
                      <MainLayout isLoggedIn={true}>
                        <AllFeesTypesPage />
                      </MainLayout>
                    } />

                    <Route path="add" element={
                      <MainLayout isLoggedIn={true}>
                        <AddFeesTypesPage />
                      </MainLayout>
                    } />

                    <Route path="details/:id" element={
                      <MainLayout isLoggedIn={true}>
                        <FeeDetailsPage />
                      </MainLayout>
                    } />

                  </Route>

                  {/* المعاملات المالية */}
                  <Route path="/transactions">
                    <Route index element={
                      <MainLayout isLoggedIn={true}>
                        <AllTransactionsPage />
                      </MainLayout>
                    } />
                    <Route path="add" element={
                      <MainLayout isLoggedIn={true}>
                        <AddTransactionPage />
                      </MainLayout>
                    } />
                    <Route path="details/:id" element={
                      <MainLayout isLoggedIn={true}>
                        <TransactionDetailsPage />
                      </MainLayout>
                    } />
                    <Route path="logs/:id" element={
                      <MainLayout isLoggedIn={true}>
                        <TransactionLogsPage />
                      </MainLayout>
                    } />
                  </Route>

                  {/* انواع المعاملات المالية */}
                  <Route path="/transactionTypes">
                    <Route index element={
                      <MainLayout isLoggedIn={true}>
                        <AllTransactionTypesPage />
                      </MainLayout>
                    } />

                    <Route path="add" element={
                      <MainLayout isLoggedIn={true}>
                        <AddTransactionTypePage />
                      </MainLayout>
                    } />

                    <Route path="details/:id" element={
                      <MainLayout isLoggedIn={true}>
                        <TransactionTypeDetailsPage />
                      </MainLayout>
                    } />

                  </Route>

                  {/* رسوم الطلاب */}
                  <Route path="/requiredFees">
                    <Route index element={
                      <MainLayout isLoggedIn={true}>
                        <AllRequiredFeesPage />
                      </MainLayout>
                    } />

                    <Route path="add" element={
                      <MainLayout isLoggedIn={true}>
                        <AddRequiredFeesPage />
                      </MainLayout>
                    } />

                    <Route path="details/:id" element={
                      <MainLayout isLoggedIn={true}>
                        <RequiredFeeDetailsPage />
                      </MainLayout>
                    } />

                  </Route>

                  {/* استمارات التسجيل */}
                  <Route path="/registerForms">
                    <Route index element={
                      <MainLayout isLoggedIn={true}>
                        <AllRegisterFormsPage />
                      </MainLayout>
                    } />
                    <Route path="details/:id" element={
                      <MainLayout isLoggedIn={true}>
                        <RegisterFormDetailsPage />
                      </MainLayout>
                    } />
                  </Route>
                  {/* الترقية */}
                  <Route path="/promotion">
                    <Route index element={
                      <MainLayout isLoggedIn={true}>
                        <PromotionPage />
                      </MainLayout>
                    } />
                    <Route path="add" element={
                      <MainLayout isLoggedIn={true}>
                        <AddPromotionPage />
                      </MainLayout>
                    } />
                  </Route>

                  {/* موافقات التذاكر */}
                  <Route path="/sequenceTrans">
                    <Route index element={
                      <MainLayout isLoggedIn={true}>
                        <AllSequenceTransPage />
                      </MainLayout>
                    } />
                    <Route path="add" element={
                      <MainLayout isLoggedIn={true}>
                        <AddSequenceTransPage />
                      </MainLayout>
                    } />
                    <Route path="details/:id" element={
                      <MainLayout isLoggedIn={true}>
                        <EditSequenceTransPage />
                      </MainLayout>
                    } />
                  </Route>

                  {/* رسائل اتصل بنا */}
                  <Route path="/contact-messages">
                    <Route index element={
                      <MainLayout isLoggedIn={true}>
                        <AllContactMessagesPage />
                      </MainLayout>
                    } />
                  </Route>

                  {/* Doctor Dashboard Pages */}
                  <Route
                    path="/DoctorlecturesSchedule"
                    element={
                      <MainLayout isLoggedIn={true}>
                        <DoctorLecturesPage />
                      </MainLayout>
                    }
                  />

                  {/* lecture Session Details     */}
                  <Route
                    path="/LectureSessionDetails"
                  >
                    <Route
                      index
                      element={
                        <MainLayout isLoggedIn={true}>
                          <AllLectureSessionsPage />
                        </MainLayout>
                      }
                    />

                    <Route
                      path=":id"
                      element={
                        <MainLayout isLoggedIn={true}>
                          <LectureSessionDetails />
                        </MainLayout>
                      }
                    />
                  </Route>

                  <Route
                    path="/exams"
                  >

                    <Route
                      index
                      element={
                        <MainLayout isLoggedIn={true}>
                          <AllExamsPage />
                        </MainLayout>
                      }
                    />

                    <Route path="add" element={
                      <MainLayout isLoggedIn={true}>
                        <AddExamPage />
                      </MainLayout>
                    } />

                    <Route path="details/:id" element={
                      <MainLayout isLoggedIn={true}>
                        <ExamDetailsPage />
                      </MainLayout>
                    } />

                    <Route path="examStudentDegrees/:id" element={
                      <MainLayout isLoggedIn={true}>
                        <ExamStudentDegreesPage />
                      </MainLayout>
                    } />

                    <Route path="examStudentDegrees/:id/add" element={
                      <MainLayout isLoggedIn={true}>
                        <AddExamStudentDegreePage />
                      </MainLayout>
                    } />

                    <Route path="examStudentDegrees/:id/details/:studentDegreeId" element={
                      <MainLayout isLoggedIn={true}>
                        <StudentDegreesDetailsPage />
                      </MainLayout>
                    } />

                    <Route path="studentDegrees/:id" element={
                      <MainLayout isLoggedIn={true}>
                        <AllDegreesForStudentPage />
                      </MainLayout>
                    } />


                  </Route>

                  <Route path="/allStudentDegrees" element={
                    <MainLayout isLoggedIn={true}>
                      <AllStudentDegreesPage />
                    </MainLayout>
                  } />

                  {/* Support tickets */}
                  <Route
                    path="/Support"
                  >
                    <Route
                      index
                      element={
                        <MainLayout isLoggedIn={true}>
                          <GetAllSupportTicketsPage />
                        </MainLayout>
                      }
                    />
                    <Route path="add" element={
                      <MainLayout isLoggedIn={true}>
                        <AddSupportTicketPage />
                      </MainLayout>
                    } />

                    <Route path="details/:id" element={
                      <MainLayout isLoggedIn={true}>
                        <EditSupportTicketPage />
                      </MainLayout>
                    } />
                  </Route>

                  {/* Support Ticket Types & Documents Management */}
                  <Route
                    path="/SupportTicketTypes"
                  >
                    <Route
                      index
                      element={
                        <MainLayout isLoggedIn={true}>
                          <AllSupportTicketTypesPage />
                        </MainLayout>
                      }
                    />
                    <Route path="add" element={
                      <MainLayout isLoggedIn={true}>
                        <AddSupportTicketTypePage />
                      </MainLayout>
                    } />
                    <Route path="details/:id" element={
                      <MainLayout isLoggedIn={true}>
                        <EditSupportTicketTypePage />
                      </MainLayout>
                    } />
                  </Route>

                  {/* Approval Sequences (TypeSequences) */}
                  <Route path="/typeSequences">
                    <Route index element={<MainLayout isLoggedIn={true}><AllTypeSequencesPage /></MainLayout>} />
                    <Route path="add" element={<MainLayout isLoggedIn={true}><AddTypeSequencePage /></MainLayout>} />
                    <Route path="details/:id" element={<MainLayout isLoggedIn={true}><EditTypeSequencePage /></MainLayout>} />
                  </Route>

                  {/* Approval Transactions (SequenceTrans) */}
                  <Route path="/sequenceTrans">
                    <Route index element={<MainLayout isLoggedIn={true}><AllSequenceTransPage /></MainLayout>} />
                    <Route path="add" element={<MainLayout isLoggedIn={true}><AddSequenceTransPage /></MainLayout>} />
                    <Route path="details/:id" element={<MainLayout isLoggedIn={true}><EditSequenceTransPage /></MainLayout>} />
                  </Route>

                  {/* Summer Course Admin */}
                  <Route
                    path="/SummerCourseAdmin/:ticketId/:studentId"
                    element={
                      <MainLayout isLoggedIn={true}>
                        <SummerCourseAdminPage />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/MaterialEquivalence/:ticketId/:studentId"
                    element={
                      <MainLayout isLoggedIn={true}>
                        <MaterialEquivalence />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/SummerCourseAdmin/:ticketId"
                    element={
                      <MainLayout isLoggedIn={true}>
                        <SummerCourseAdminPage />
                      </MainLayout>
                    }
                  />
                </Route>

                <Route path="/Maintenance" element={<Maintenance />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </main>
            <Footer />
          </div>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={i18n.language === "ar"}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme={mode}
          />
        </ThemeProvider>
      </CacheProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
